var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media/ Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.3999 3.64435C2.3999 2.95706 2.95706 2.3999 3.64435 2.3999H5.68476C5.95259 2.3999 6.19036 2.57128 6.27506 2.82536L7.20703 5.62128C7.30495 5.91504 7.17196 6.2361 6.895 6.37457L5.49048 7.07683C6.17632 8.59799 7.40181 9.82348 8.92297 10.5093L9.62523 9.1048C9.76371 8.82784 10.0848 8.69486 10.3785 8.79278L13.1744 9.72475C13.4285 9.80944 13.5999 10.0472 13.5999 10.315V12.3555C13.5999 13.0427 13.0427 13.5999 12.3555 13.5999H11.7332C6.57858 13.5999 2.3999 9.42123 2.3999 4.26657V3.64435Z",
    stroke: "#9F9F9F",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.7b74b52434680b1833ef365ad3c9ce64.svg";
export { ForwardRef as ReactComponent };